export default {
    timezone: 'timezone',
    hashes: 'hashes',
    modules: 'modules',
    tabs: 'tabs',
    columns: 'columns',
    dataExportFields: 'dataExportFields',
    notifications: 'notifications',
    sort: 'gridSort',
};
